import axios from "axios";

export default {
  getItems: function (baseApiUrl, utbildningOptions) {
    var response = axios.post(
      baseApiUrl + "/UtbildningList",
      utbildningOptions,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  },
};
